import React from 'react';
import { Box, Flex, Heading, Text } from '@podiumhq/design-system';

import { usePricingPackagingContext } from 'contexts/PricingPackagingContextProvider';

import {
  BUNDLE_PACKAGES_LIST,
  PACKAGE_TITLES,
  YEARLY_TERM,
} from '../constants';
import { columnStyles } from '../styles';

import ChatWithSalesButton from './ChatWithSalesButton';

const RowWithHeaderPriceCta = (props) => {
  const {
    canChoosePlan,
    currentPlan: currentBundle,
    displayPrice,
    onBundleCardCtaOnClick: handleCtaOnClick,
  } = usePricingPackagingContext();

  return (
    <Box
      backgroundColor="silver.lightest"
      padding="8px 0"
      position="sticky"
      top="0"
      zIndex="100"
    >
      <Flex mb={displayPrice ? 0 : 3} {...props}>
        <Spacer />
        {BUNDLE_PACKAGES_LIST.map((bundleName) => (
          <Heading key={bundleName} {...headingStyles}>
            {PACKAGE_TITLES[bundleName]}
          </Heading>
        ))}
      </Flex>

      {displayPrice && (
        <Flex mb={handleCtaOnClick ? 0 : 3} {...props}>
          <Spacer />
          {BUNDLE_PACKAGES_LIST.map((bundleName) => (
            <SelectedPriceDisplay key={bundleName} bundleName={bundleName} />
          ))}
        </Flex>
      )}

      {handleCtaOnClick && (
        <Flex mb={2} {...props}>
          <Spacer />
          {BUNDLE_PACKAGES_LIST.map((bundleName) => (
            <Flex {...listColumnStyles} key={bundleName}>
              <ChatWithSalesButton
                canChoosePlan={canChoosePlan}
                currentBundle={currentBundle === bundleName}
                handleOnClick={() => handleCtaOnClick(bundleName)}
                size="sm"
              />
            </Flex>
          ))}
        </Flex>
      )}
    </Box>
  );
};

const SelectedPriceDisplay = ({ bundleName }) => {
  const { monthlyPackagePrices, priceTerm, yearlyPackagePrices } =
    usePricingPackagingContext();

  return (
    <Flex {...headingStyles}>
      $
      {priceTerm === YEARLY_TERM
        ? yearlyPackagePrices[bundleName]
        : monthlyPackagePrices[bundleName]}
      <Text {...priceTextStyles}>USD /month</Text>
    </Flex>
  );
};

const Spacer = () => <Flex {...firstListColumnStyles}>{''}</Flex>;

const listColumnStyles = {
  ...columnStyles,
  justify: 'center',
  textAlign: 'center',
  width: '25%',
};

const firstListColumnStyles = {
  ...listColumnStyles,
  justify: 'flex-start',
};

const headingStyles = {
  ...listColumnStyles,
  fontSize: '2xl',
  fontWeight: 'semibold',
};

const priceTextStyles = {
  color: 'grey.light',
  fontSize: 'md',
  fontWeight: 'normal',
  ml: '4px',
};

export default RowWithHeaderPriceCta;
